import { render, staticRenderFns } from "./my-add-contact-popup.vue?vue&type=template&id=61056c52&scoped=true&"
import script from "./my-add-contact-popup.vue?vue&type=script&lang=js&"
export * from "./my-add-contact-popup.vue?vue&type=script&lang=js&"
import style0 from "./my-add-contact-popup.vue?vue&type=style&index=0&id=61056c52&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61056c52",
  null
  
)

export default component.exports